import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CloudSvg = function CloudSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.832 5.897a5.8 5.8 0 0 1 4.147-.802 5.8 5.8 0 0 1 3.593 2.231 5.86 5.86 0 0 1 1.17 3.447 4.4 4.4 0 0 1 2.229 1.436 4.456 4.456 0 0 1-.36 6.082 4.4 4.4 0 0 1-3.033 1.208H7.346a5.33 5.33 0 0 1-3.91-1.71 5.38 5.38 0 0 1-1.423-4.04A5.4 5.4 0 0 1 3.98 9.947 5.34 5.34 0 0 1 7.5 8.749a5.84 5.84 0 0 1 2.332-2.852m3.895.578a4.4 4.4 0 0 0-3.152.61 4.44 4.44 0 0 0-1.91 2.592l-.161.596-.609-.085a3.94 3.94 0 0 0-3.036.848 3.97 3.97 0 0 0-1.454 2.81 4 4 0 0 0 1.052 2.986 3.95 3.95 0 0 0 2.89 1.265h10.232c.771 0 1.514-.296 2.075-.827a3.045 3.045 0 0 0 .247-4.161 3.02 3.02 0 0 0-1.963-1.068l-.678-.082.066-.683a4.46 4.46 0 0 0-.868-3.106 4.42 4.42 0 0 0-2.73-1.695",
    clipRule: "evenodd"
  }));
};
export var Cloud = function Cloud(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CloudSvg
  }));
};